import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '@/router';
import Swal from 'sweetalert2';

axios.defaults.baseURL = process.env.VUE_APP_BASEURL_API;

Vue.use(Vuex);

const listLimit = 12;

export default new Vuex.Store({
  state: {
      baseURL: process.env.VUE_APP_BASEURL,
      category: []
  },
  mutations: {
  },
  actions: {
      loading() {
          Swal.fire({
              title: 'Sedang Memuat',
              text: 'Tunggu Sebentar',
              allowEscapeKey: false,
              allowOutsideClick: false,
              onOpen: () => {
                  Swal.showLoading();
              }
          });
      },
      async loadingClose() {
          Swal.close();
      },
      requestError({dispatch}, error) {
          if(error.response !== undefined) {
              if(error.response.data.errors !== undefined && error.response.data.errors.length > 0) {
                  if(error.response.data.errors[0] === 'Token is Invalid. Please Login Again.' || error.response.data.errors[0] === 'Token is Expired. Please Login Again.') {
                      Swal.close();
                      dispatch('logout', router.history.current.path);
                  } else {
                      Swal.fire({
                          icon: 'error',
                          html: '<span style="color:#ff5252;">'+error.response.data.errors[0]+'</span>',
                          confirmButtonText: 'OK',
                          allowOutsideClick: false,
                          allowEscapeKey: false,
                          allowEnterKey: false,
                          onOpen: () => {
                              Swal.hideLoading();
                          }
                      });
                  }
              } else {
                  Swal.fire({
                      icon: 'error',
                      html: '<span style="color:#ff5252;">Something wrong in System, Please try again or contact administrator.</span>',
                      confirmButtonText: 'OK',
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      allowEnterKey: false,
                      onOpen: () => {
                          Swal.hideLoading();
                      }
                  });
              }   
          } else {
              Swal.fire({
                  icon: 'error',
                  html: '<span style="color:#ff5252;">'+error.message+', Please try again or contact administrator.</span>',
                  confirmButtonText: 'OK',
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  onOpen: () => {
                      Swal.hideLoading();
                  }
              });
          }
      },
      requestSuccess(_context, message) {
          Swal.fire({
              icon: 'success',
              html: '<span style="color:#4caf50;">'+message+'</span>',
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              onOpen: () => {
                  Swal.hideLoading();
              }
          }).then(() => {
              Swal.close();
          });
      },
      async numberWithDots(_context, x) {
          return new Promise((resolve) => {
              resolve(x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));
          });
      },
      async requestAPI(context, {name,params}) {
          let method = 'GET';
          let url = '';
          switch(name) {
                case 'category/all':
                    context.dispatch('loading');
                    method = 'GET';
                    url = 'category/all';
                    break;
                case 'category/products':
                    context.dispatch('loading');
                    method = 'GET';
                    url = 'category/products/'+params.id+'?limit='+listLimit+'&page='+params.page;
                    break;
                case 'product/detail':
                    context.dispatch('loading');
                    method = 'GET';
                    url = 'product/detail/'+params.id;
                    break;
                case 'promo/lists':
                    context.dispatch('loading');
                    method = 'GET';
                    url = 'promo/lists?limit='+listLimit+'&page='+params.page;
                    break;
                case 'promo/detail':
                    context.dispatch('loading');
                    method = 'GET';
                    url = 'promo/detail/'+params.id;
                    break;
                case 'contact-us':
                    context.dispatch('loading');
                    method = 'GET';
                    url = 'contact-us';
                    break;

                default:
                    url = '';
          }
          try {
              let res = await context.dispatch('requestAPIProcess', {
                  method: method,
                  url: url,
                  params: params
              });
              return res;
          } catch (err) {
              context.dispatch('requestError', err);
          }
    },
    async requestAPIProcess(context, {method, url, params}) {
        let res;
        if(url === 'talent/document/create' || url === 'talent/document/update') {
            if(url === 'talent/document/update') {
                url = url+'/'+params.id;
            }

            let formData = new FormData()
            formData.append('name', params.data.name)
            formData.append('file', params.data.file)
            res = await axios({
                method: 'POST',
                url: url,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        } else {
            if(method === 'POST') {
                res = await axios({
                    method: method,
                    url: url,
                    data: params.data
                });
            } else {
                res = await axios({
                    method: method,
                    url: url
                });
            }
        }
        Swal.showLoading();
        Swal.close();
        return res;
    },
  },
  modules: {
  }
})
